import { render, staticRenderFns } from "./IssueStatusButton.vue?vue&type=template&id=366b227e&scoped=true&"
import script from "./IssueStatusButton.vue?vue&type=script&lang=js&"
export * from "./IssueStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./IssueStatusButton.vue?vue&type=style&index=0&id=366b227e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b227e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366b227e')) {
      api.createRecord('366b227e', component.options)
    } else {
      api.reload('366b227e', component.options)
    }
    module.hot.accept("./IssueStatusButton.vue?vue&type=template&id=366b227e&scoped=true&", function () {
      api.rerender('366b227e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Issues/Buttons/IssueStatusButton.vue"
export default component.exports